import { toastManager as e } from "@systemeio/components";
//#region src/components/toast/index.ts
var t = (t, n) => e.add({
	type: t,
	title: n
}), n = Object.assign((e) => t("info", e), {
	error: (e) => t("error", e),
	success: (e) => t("success", e)
});
//#endregion
export { n as toast };
